import { DonorSupportChannelResolution } from "./useDonorSupportChannel";
import { usePublishSupportChannel } from "./usePublishSupportChannel";

import { AmplitudeEvents } from "@/common/constants/amplitude";

interface UsePublishDonorSupportChannelProps {
  resolution: DonorSupportChannelResolution;
  path: string;
  enabled: boolean;
}

export const usePublishDonorSupportChannel = (props: UsePublishDonorSupportChannelProps) =>
  usePublishSupportChannel({ ...props, event: AmplitudeEvents.DonorSupportChannelResolved });
